import React, { useState, useEffect, useRef } from 'react';
import { HelpCircle } from 'lucide-react';

interface HelpIconProps {
  message: string;
}

const HelpIcon: React.FC<HelpIconProps> = ({ message }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const tooltipRef = useRef<HTMLDivElement>(null);

  // Close tooltip when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (tooltipRef.current && !tooltipRef.current.contains(event.target as Node)) {
        setShowTooltip(false);
      }
    };

    if (showTooltip) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showTooltip]);

  return (
    <div style={{ position: 'relative', marginLeft: '10px', cursor: 'pointer' }}>
      <HelpCircle
        size={16}
        color="#0066cc"
        onClick={() => setShowTooltip((prev) => !prev)}
      />
      {showTooltip && (
        <div
          ref={tooltipRef}
          style={{
            position: 'absolute',
            top: '25px',
            left: '0',
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            padding: '10px',
            fontSize: '14px',
            borderRadius: '4px',
            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
            zIndex: 10,
            width: '250px', // Increased width
          }}
        >
          {message}
        </div>
      )}
    </div>
  );
};

export default HelpIcon;
